<template>
  <div>
    <div calss="">
      <HomeVue v-if="view == 'home'" />
      <CitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'cita'" />
      <Citasview @setView="setView" v-else-if="view == 'cita'" />
      
      <ListaCitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'lista_citas'" />
      <ListaCitasview @setView="setView" v-else-if="view == 'lista_citas'" /> 
      <!-- <ReportView v-if="view == 'reports'" @setView="setView" /> -->
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import FooterVue from "../../components/personal/Katalynas/Footer.vue";
import HomeVue from "../../components/personal/Katalynas/Home.vue";
import Citasview from "../../components/citas/Citasview.vue";
import ListaCitasview from "../../components/citas/ListaCitasview.vue";
// import ReportView from '../reports/ReportsView.vue';

// ISEA
import CitasIseaview from "../../components/citas/isea/Citasview.vue";
import ListaCitasIseaview from "../../components/citas/isea/ListaCitasview.vue";

export default {
  components: { 
    FooterVue, 
    HomeVue, 
    Citasview, 
    ListaCitasview,
    CitasIseaview,
    ListaCitasIseaview
  },
  data() {
    return {
      view: "home",
    };
  },
  methods: {
    setView: function (payload) {
      this.view = payload;
    },
  },
};
</script>

<style lang="scss" scoped></style>